import React, { useEffect, useState } from 'react'
import dayjs from 'dayjs';
import { useParams } from 'react-router-dom';

import Button from "../../../../../../components/uiComponent/button";
import ReactSelect from '../../../../../../components/uiComponent/select';

import { StepFourWrapper } from '../style';
import { useDispatch, useSelector } from 'react-redux';
import { DownloadBillOfLading, GetLabels, GetShipmentBoxes, UpdateShipmentTrackingDetails } from '../../../../../../slices/post-shipment';
import PackScanModal from './PackScanModal';

const StepFour = ({
  printBoxGlobal,
  shipments,
  shipmentType,
  packingMethod,
  transportationDetails = [],
  onCancelPlan,
  cancelingInboundPlan
}) => {

  const [boxLabelsLoading, setBoxLabelsLoading] = useState({});
  const [carrierLabelsLoading, setCarrierLabelsLoading] = useState({});
  const [palletsLoading, setPalletsLoading] = useState({});
  const [allBolLoading, setAllBolLoading] = useState({});
  const [carrierLabelPageTypes, setCarrierLabelPageTypes] = useState({});
  const [palletLabelPageType, setPalletLabelPageType] = useState('PackageLabel_Thermal_NonPCP');
  const [packScanVisible, setPackScanVisible] = useState(false);
  const [shipmentBoxes, setShipmentBoxes] = useState({});
  const [trackingIds, setTrackingIds] = useState({});
  const [submittingTracking, setSubmittingTracking] = useState({});

  const { workOrderId } = useParams();

  const {
    bolLoading,
    shipmentDetails,
  } = useSelector((state) => state.postShipment || {});
  const { amazonInboundPlanId: inboundPlanId } = shipmentDetails || {};
  const { currentUser } = useSelector((state) => state.auth || {});

  const dispatch = useDispatch();

  const formatShipmentDate = (shipment) => {
    if (!shipment) return '---';
    const { start_date, created_at, name } = shipment;
    
    // Try start_date or created_at first
    if (start_date || created_at) {
      const d = dayjs(start_date || created_at);
      if (d.isValid()) return d.format("YYYY-MM-DD");
    }
    
    // Fallback: try to extract from name "FBA STA (05/02/2026 16:39)-TMB8"
    if (name) {
      const match = name.match(/\((\d{2})\/(\d{2})\/(\d{4})/);
      if (match) {
        const [_, month, day, year] = match;
        const parsed = dayjs(`${year}-${month}-${day}`);
        if (parsed.isValid()) return parsed.format("YYYY-MM-DD");
      }
    }
    
    return '---';
  };

  const getShipmentMode = (shipmentId) => {
    if (packingMethod !== 'pack_now') return 'LTL';

    const shipment = shipments.find(s => s.amazon_shipment_id === shipmentId) || {};
    const detail = transportationDetails.find(({ shipmentId: id }) => id === shipmentId) || {};
    const mode = shipment.shipment_type || detail.shipmentType || detail.shipment_type || shipmentType || '';

    if (mode === 'GROUND_SMALL_PARCEL' || mode === 'SP' || mode === 'SPD') return 'SP';
    if (mode === 'LESS_THAN_TRUCKLOAD' || mode === 'LTL') return 'LTL';

    return 'SP';
  };

  const boxLabelPageOptions = [
    { label: 'Letter 2', value: 'PackageLabel_Letter_2' },
    { label: 'Letter 4', value: 'PackageLabel_Letter_4' },
    { label: 'Letter 6', value: 'PackageLabel_Letter_6' },
    { label: 'A4 2', value: 'PackageLabel_A4_2' },
    { label: 'A4 4', value: 'PackageLabel_A4_4' },
    { label: 'Plain Paper', value: 'PackageLabel_Plain_Paper' },
    { label: 'Thermal', value: 'PackageLabel_Thermal' },
    { label: 'Thermal Unified', value: 'PackageLabel_Thermal_Unified' },
    { label: 'Thermal Non-PCP', value: 'PackageLabel_Thermal_NonPCP' },
  ];

  const carrierLabelPageOptions = [
    { label: 'Letter-4', value: 'PackageLabel_Letter_4' },
    { label: 'Letter-6', value: 'PackageLabel_Letter_6' },
    { label: 'A4 2', value: 'PackageLabel_A4_2' },
    { label: 'A4 4', value: 'PackageLabel_A4_4' },
    { label: 'Thermal (4X6)', value: 'PackageLabel_Thermal' },
    { label: 'Thermal Unified (4X6)', value: 'PackageLabel_Thermal_Unified' },
    { label: 'Thermal Non-PCP (4X6)', value: 'PackageLabel_Thermal_NonPCP' },
  ];

  const getCarrierType = (shipmentId) => {
    const shipment = shipments.find(s => s.amazon_shipment_id === shipmentId) || {};
    const detail = transportationDetails.find(({ shipmentId: id }) => id === shipmentId) || {};
    return shipment.carrier_type || detail.carrierType || detail.carrier_type || '';
  };

  const getCarrierPageType = (shipmentId) => {
    if (carrierLabelPageTypes[shipmentId]) return carrierLabelPageTypes[shipmentId];
    return getCarrierType(shipmentId) === 'non-partnered'
      ? 'PackageLabel_Thermal_NonPCP'
      : 'PackageLabel_Thermal';
  };

  

  // const handleSubmitTrackingIds = async (shipmentId) => {
  //   const boxes = shipmentBoxes[shipmentId] || [];
  //   const ids = trackingIds[shipmentId] || {};
  //   const missing = boxes.some(b => !ids[b.boxId]?.trim());
  //   if (missing) {
  //     notification.error({ message: 'Please enter a tracking ID for every box' });
  //     return;
  //   }
  //   setSubmittingTracking(prev => ({ ...prev, [shipmentId]: true }));
  //   await dispatch(UpdateShipmentTrackingDetails({
  //     inboundPlanId,
  //     shipmentId,
  //     trackingDetails: {
  //       spdTrackingDetail: {
  //         spdTrackingItems: boxes.map(b => ({ boxId: b.boxId, trackingId: ids[b.boxId] }))
  //       }
  //     }
  //   }));
  //   setSubmittingTracking(prev => ({ ...prev, [shipmentId]: false }));
  // };

  const printBoxLabels = (shipmentId) => {
    setBoxLabelsLoading(prev => ({ ...prev, [shipmentId]: true }));
    let pageType = boxLabelPageType;
    if (getShipmentMode(shipmentId) === 'SP' && getCarrierType(shipmentId) === 'non-partnered') {
      pageType = 'PackageLabel_Thermal_NonPCP';
    }
    const body = {
      shipmentId,
      PageType: pageType,
      LabelType: 'UNIQUE',
      PageStartIndex: 0
    };
    dispatch(GetLabels(body)).then(() => {
      setBoxLabelsLoading(prev => ({ ...prev, [shipmentId]: false }));
    });
  };

  const printCarrierLabels = (shipmentId) => {
    setCarrierLabelsLoading(prev => ({ ...prev, [shipmentId]: true }));
    const shipment = shipments.find(s => s.amazon_shipment_id === shipmentId) || {};
    const boxCount = shipment.boxes_info?.length || 0;
    const cartonIdList = shipment.boxes_info?.map(b => b.amazon_box_id || b.amazonBoxId).filter(Boolean) || [];
    const body = {
      shipmentId,
      PageType: getCarrierPageType(shipmentId),
      LabelType: 'UNIQUE',
      NumberOfPackages: boxCount,
      PageSize: boxCount,
      cartonIdList
    };
    dispatch(GetLabels(body)).then(() => {
      setCarrierLabelsLoading(prev => ({ ...prev, [shipmentId]: false }));
    });
  };

  const printPalletLabels = (shipmentId) => {
    setPalletsLoading((prev) => ({ ...prev, [shipmentId]: true }));
    const body = {
      shipmentId,
      PageType: palletLabelPageType,
      LabelType: 'PALLET',
      PageStartIndex: 0
    };
    dispatch(GetLabels(body)).then(() => {
      setPalletsLoading((prev) => ({ ...prev, [shipmentId]: false }));
    });
  };

  const renderTrackingSection = (shipmentId) => {
    const boxes = shipmentBoxes[shipmentId] || [];
    const ids = trackingIds[shipmentId] || {};
    const isSubmitting = submittingTracking[shipmentId] || false;

    return (
      <div style={{ marginTop: '12px', width: '100%' }}>
        <Divider style={{ margin: '8px 0' }} />
        <p style={{ fontWeight: 600, fontSize: '12px', marginBottom: '8px' }}>Tracking IDs</p>
        {boxes.length === 0 ? (
          <p style={{ fontSize: '12px', color: '#808183' }}>Loading boxes...</p>
        ) : (
          <>
            {boxes.map((box, i) => (
              <div key={box.boxId} style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
                <span style={{ fontSize: '12px', color: '#535E63', minWidth: '60px' }}>Box {i + 1}</span>
                <AntInput
                  size="small"
                  placeholder="Enter tracking ID"
                  value={ids[box.boxId] || ''}
                  onChange={e => setTrackingIds(prev => ({
                    ...prev,
                    [shipmentId]: { ...prev[shipmentId], [box.boxId]: e.target.value }
                  }))}
                  style={{ fontSize: '12px' }}
                />
              </div>
            ))}
            {/* <Button
              text={isSubmitting ? 'Submitting...' : 'Submit Tracking IDs'}
              className="mb-0"
              size="small"
              disabled={isSubmitting}
              onClick={() => handleSubmitTrackingIds(shipmentId)}
              style={{ marginTop: '8px' }}
            /> */}
          </>
        )}
      </div>
    );
  };

  const downloadBillOfLading = (shipmentId) => {
    setAllBolLoading((prev) => ({ ...prev, [shipmentId]: true }));
    dispatch(DownloadBillOfLading(shipmentId)).then(() => {
      setAllBolLoading((prev) => ({ ...prev, [shipmentId]: false }));
    })
  };

  const {
    source_name,
    source_address_line_1,
    source_city,
    source_state_or_province,
    source_postal_code,
    source_country_code,

    destination_name,
    destination_address_line_1,
    destination_city,
    destination_state_or_province_code,
    destination_postal_code,
    destination_country_code,
  } = shipments?.[0] || {};

  const sourceAddress = `${source_name || ''}, ${source_address_line_1 || ''}, ${source_city || ''}, ${source_state_or_province || ''} ${source_postal_code || ''}, ${source_country_code || ''}`;
  const destinationAddress = `${destination_name || ''}, ${destination_address_line_1 || ''}, ${destination_city || ''}, ${destination_state_or_province_code || ''} ${destination_postal_code || ''}, ${destination_country_code || ''}`;

  return (
    <StepFourWrapper>
      {packingMethod === 'pack_now' && (
        <div style={{ position: 'absolute', top: '-10px', right: '0px', zIndex: 10 }}>
          <Button
            className="pack-scan-button-primary"
            text="📦 Pack & Scan"
            onClick={() => setPackScanVisible(true)}
            style={{ 
              background: 'linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)',
              color: 'white',
              border: 'none',
              fontWeight: 700,
              borderRadius: '8px',
              padding: '10px 24px',
              boxShadow: '0 4px 12px rgba(37, 99, 235, 0.2)',
              cursor: 'pointer'
            }}
          />
        </div>
      )}
      <div className={`${printBoxGlobal ? 'show-global' : 'hide-global'}`}>
        {/* Step Header with Actions */}
        <div className="step-header-actions" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', marginBottom: '1.5rem', gap: '10px' }}>
       
          {false && (
            <Button
              className="pack-scan-button-primary"
              text="📦 Pack & Scan"
              onClick={() => setPackScanVisible(true)}
              style={{ 
                background: 'linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%)',
                color: 'white',
                border: 'none',
                fontWeight: 700,
                borderRadius: '10px',
                padding: '10px 20px',
                boxShadow: '0 4px 12px rgba(37, 99, 235, 0.25)',
                cursor: 'pointer'
                
              }}
            />
          )}
        </div>

        {!printBoxGlobal ? <>
          <div className='items-wrapper-main'>
            <div className='items'>
              <p>Name</p>
              <p>{shipments[0]?.name || ''}</p>
            </div>
            <div className='items'>
              <p>Date</p>
              <p>{formatShipmentDate(shipments[0])}</p>
            </div>
            <div className='items'>
              <p>ID</p>
              <p>{shipments[0]?.amazon_shipment_confirmation_id || shipments[0]?.amazon_shipment_id || ''}</p>
            </div>
            <div className='items'>
              <p>Amazon Reference ID</p>
              <p>{shipments[0]?.amazon_reference_id || shipments[0]?.amazon_shipment_confirmation_id || '---'}</p>
            </div>
            <div className='items'>
              <p>Ship From</p>
              <p>{sourceAddress || ''}</p>
            </div>
            <div className='items'>
              <p>Ship To</p>
              <p>{destinationAddress || ''}</p>
            </div>
          </div>
          <div className='select-overlay-wrappers'>
            {getShipmentMode(shipments[0]?.amazon_shipment_id) === 'SP' ? (
              <div className='select-items-buttons'>
                {packingMethod === 'pack_now' && (
                  <ReactSelect
                    options={carrierLabelPageOptions}
                    value={carrierLabelPageOptions.find(o => o.value === getCarrierPageType(shipments[0]?.amazon_shipment_id)) || null}
                    onChange={opt => setCarrierLabelPageTypes(prev => ({ ...prev, [shipments[0]?.amazon_shipment_id]: opt?.value }))}
                    placeholder="Select label type"
                  />
                )}
                <Button
                  disabled={!!carrierLabelsLoading[shipments[0]?.amazon_shipment_id]}
                  className="default-billing"
                  text={getCarrierType(shipments[0]?.amazon_shipment_id) === 'non-partnered' ? 'Download Shipment ID' : 'Download Shipment ID and Carrier Labels'}
                  onClick={() => printCarrierLabels(shipments[0]?.amazon_shipment_id)}
                  width="100%"
                  height="32px"
                />
                {/* {getCarrierType(shipments[0]?.amazon_shipment_id) === 'non-partnered' && renderTrackingSection(shipments[0]?.amazon_shipment_id)} */}
              </div>
            ) : (
              <>
                <div className='select-items'>
                  <Button
                    disabled={!!palletsLoading[shipments[0]?.amazon_shipment_id]}
                    className="default-billing"
                    text="Download Pallets Labels"
                    onClick={() => printPalletLabels(shipments[0]?.amazon_shipment_id)}
                  />
                </div>
                <Button
                  disabled={bolLoading}
                  onClick={() => downloadBillOfLading(shipments[0]?.amazon_shipment_id)}
                  className="default-billing"
                  text="Download Bill of Lading"
                />
              </>
            )}
          </div>
        </>
          :
          <div className='cards-group-wrapper'>
            {shipments && shipments?.map((shipmentDetails, shipmentIndex) => {
              const shipmentId = shipmentDetails?.amazon_shipment_id;
              const amazonShipmentConfirmationId = shipmentDetails?.amazon_shipment_confirmation_id;
              const isPalletsLoading = palletsLoading[shipmentId] || false;
              const isBolLoading = allBolLoading[shipmentId] || false;

              const {
                source_name,
                source_address_line_1,
                source_city,
                source_state_or_province,
                source_postal_code,
                source_country_code,

                destination_name,
                destination_address_line_1,
                destination_city,
                destination_state_or_province_code,
                destination_postal_code,
                destination_country_code,
              } = shipmentDetails || {};

              const sourceAddress = `${source_name || ''}, ${source_address_line_1 || ''}, ${source_city || ''}, ${source_state_or_province || ''} ${source_postal_code || ''}, ${source_country_code || ''}`;
              const destinationAddress = `${destination_name || ''}, ${destination_address_line_1 || ''}, ${destination_city || ''}, ${destination_state_or_province_code || ''} ${destination_postal_code || ''}, ${destination_country_code || ''}`;

              return (
                <div className='cards-group' key={shipmentIndex}>
                  <h6>{ amazonShipmentConfirmationId || shipmentId }</h6>
                  <div className='items-wrapper-main'>
                    <div className='items'>
                      <p>Name</p>
                      <p>{shipmentDetails?.name || ''}</p>
                    </div>
                    <div className='items'>
                      <p>Date</p>
                      <p>{formatShipmentDate(shipmentDetails)}</p>
                    </div>
                    <div className='items'>
                      <p>ID</p>
                      <p>{shipmentDetails?.amazon_shipment_confirmation_id || shipmentDetails?.amazon_shipment_id || ''}</p>
                    </div>
                    <div className='items'>
                      <p>Amazon Reference ID</p>
                      <p>{shipmentDetails?.amazon_reference_id || shipmentDetails?.amazon_shipment_confirmation_id || '---'}</p>
                    </div>
                    <div className='items'>
                      <p>Ship From</p>
                      <p>{sourceAddress || ''}</p>
                    </div>
                    <div className='items'>
                      <p>Ship To</p>
                      <p>{destinationAddress || ''}</p>
                    </div>
                  </div>
                  {getShipmentMode(shipmentId) === 'SP' ? (
                    <div className='select-overlay-wrappers'>
                      <div className='select-items-buttons'>
                        {packingMethod === 'pack_now' && (
                          <ReactSelect
                            options={carrierLabelPageOptions}
                            value={carrierLabelPageOptions.find(o => o.value === getCarrierPageType(shipmentId)) || null}
                            onChange={opt => setCarrierLabelPageTypes(prev => ({ ...prev, [shipmentId]: opt?.value }))}
                            placeholder="Select label type"
                          />
                        )}
                        <Button
                          disabled={!!carrierLabelsLoading[shipmentId]}
                          className="billing-button"
                          text={getCarrierType(shipmentId) === 'non-partnered' ? 'Download Shipment ID' : 'Download Shipment ID and Carrier Labels'}
                          onClick={() => printCarrierLabels(shipmentId)}
                          width="100%"
                          height="32px"
                        />
                        {/* {getCarrierType(shipmentId) === 'non-partnered' && renderTrackingSection(shipmentId)} */}
                      </div>
                    </div>
                  ) : (
                    <div className='select-overlay-wrappers flex'>
                      <div className='select-items-buttons'>
                        <Button
                          disabled={isPalletsLoading}
                          className="default-billing"
                          text="Download Pallets Labels"
                          onClick={() => printPalletLabels(shipmentId)}
                        />
                        <Button
                          disabled={isBolLoading}
                          onClick={() => downloadBillOfLading(shipmentId)}
                          className="billing-button"
                          text="Download Bill of Lading"
                        />
                      </div>
                    </div>
                  )}
                </div>
              )
            }
            )}
          </div>}

      </div>

      {(packingMethod === 'pack_now' || currentUser?.role?.id === 5) && (
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '16px' }}>
          <Button
            text="Cancel Plan"
            className="danger mb-0"
            minWidth="80px"
            size="small"
            disabled={cancelingInboundPlan}
            onClick={onCancelPlan}
          />
        </div>
      )}

      {/* Pack & Scan Modal */}
      <PackScanModal
        open={packScanVisible}
        onClose={() => setPackScanVisible(false)}
        workOrderId={workOrderId}
      />
    </StepFourWrapper>
  )
}

export default StepFour;
